module.exports = __webpack_public_path__ + "static/media/cnito_live_bg_web.08867543.svg";